import { Select } from '@/components';
import { MasterInfoEnum, OPTION_SELECT, OPTION_SELECT_ALL } from '@/constant';
import { useCommonList } from '@/hooks';
import React, { memo, useCallback, useMemo } from 'react';

import { SelectProps } from 'antd';
import { DefaultOptionType } from 'antd/es/select';

import './style.scss';
import { Field, FieldProps } from 'formik';

export interface IFSelect extends SelectProps {
	type?: MasterInfoEnum;
	name: string;
	selectClassName?: string;
	isSelectAll?: boolean;
	required?: boolean;
	searchStartsWith?: boolean;
	hasServerError?: boolean;
}
const FSelectInput: React.FC<IFSelect> = ({
	type,
	name,
	selectClassName,
	isSelectAll,
	required,
	...rest
}) => {
	const { selectMasterInfo } = useCommonList(type);

	const formatSelectOption = useCallback(
		(data: DefaultOptionType[] = []) => {
			let newData = [...data];
			if (!rest?.placeholder) {
				newData = [isSelectAll ? OPTION_SELECT_ALL : OPTION_SELECT, ...data];
			}
			return newData;
		},
		[rest.placeholder, isSelectAll]
	);

	const _options = useMemo(() => {
		if (type) {
			return formatSelectOption(selectMasterInfo?.data);
		}
		return rest.options;
	}, [type, formatSelectOption, selectMasterInfo, rest.options]);

	return (
		<Field name={name}>
			{({
				field, // { name, value, onChange, onBlur }
				form: { setFieldValue, setFieldTouched }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
				meta,
			}: FieldProps) => {
				const _onChange = (
					value: any,
					option: DefaultOptionType | DefaultOptionType[]
				) => {
					setFieldValue(name, value);
				};
				return (
					<Select
						{...field}
						{...rest}
						options={_options}
						onChange={_onChange}
						touched={meta.touched}
						errorCode={meta.error}
					/>
				);
			}}
		</Field>
	);
};

export default memo(FSelectInput);
